import React from "react";
import { Grid, Typography, Tooltip, Box } from "@mui/material";
import SimilarityPercentage from "components/CaseManagement/SimilarCases/SimilarityPercentage";
import { useSimilarCasesData } from "components/CaseManagement/SimilarCases/SimilarCasesContext";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { lighten } from "@mui/material/styles";

export function SimilarCasesTable({ setSelectedSimilarCase }) {
  const { similarCases } = useSimilarCasesData();

  const headers = ["Case", "Similarity", "Component", "Failure Mode"];

  return (
    <>
      <HeadersWrapper container direction="row" alignItems="center">
        {headers.map(headerName => (
          <Grid item xs={3} key={headerName}>
            <Typography noWrap color="textSecondary">
              {headerName}
            </Typography>
          </Grid>
        ))}
      </HeadersWrapper>
      {similarCases?.map(similarCase => (
        <CaseBox border={1.5} borderRadius="borderRadius" key={similarCase.id}>
          <ClickableRow onClick={() => setSelectedSimilarCase(similarCase)}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={3}>
                <Typography display="block" noWrap>
                  #{similarCase.display_id}
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  color="textSecondary"
                >
                  {similarCase.open ? "Open" : "Closed"}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <SimilarityPercentage rawScore={similarCase.score} />
              </Grid>
              <Grid item xs={3}>
                <Tooltip title={similarCase.component_name}>
                  <TruncatedTypography>
                    {similarCase.component_name}
                  </TruncatedTypography>
                </Tooltip>
              </Grid>
              <Grid item xs={3}>
                <Tooltip title={similarCase.failure_mode_name}>
                  <TruncatedTypography>
                    {similarCase.failure_mode_name}
                  </TruncatedTypography>
                </Tooltip>
              </Grid>
            </Grid>
          </ClickableRow>
        </CaseBox>
      ))}
    </>
  );
}

const HeadersWrapper = styled(Grid)`
  padding-bottom: ${props => props.theme.spacing(2)};
  padding-left: ${props => props.theme.spacing(1)};
  padding-right: ${props => props.theme.spacing(1)};
`;

const ClickableRow = styled("div")`
  cursor: pointer;
  padding: ${props => props.theme.spacing(1)};
  &:hover {
    background-color: ${props =>
      lighten(props.theme.palette.primary.main, 0.8)};
  }
`;

const CaseBox = styled(Box)`
  margin-bottom: ${props => props.theme.spacing(1)};
  border-color: lightgray;
`;

const TruncatedTypography = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

SimilarCasesTable.propTypes = {
  setSelectedSimilarCase: PropTypes.func
};
